"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dm.communicationType.wa': 'WA',
    'whatsapp.dm.communicationType.tele': 'TELE',
    'whatsapp.dm.loading': '加载中...',
    'whatsapp.dm.back': '返回',
    'whatsapp.dm.contactInfo': '联系人信息',
    'whatsapp.dm.contactName': '名称',
    'whatsapp.dm.contactId': '联系人ID',
    'whatsapp.dm.messages': '消息',
    'whatsapp.dm.noMessages': '未找到此日期范围内的消息。',
    'whatsapp.dm.dateFrom': '从',
    'whatsapp.dm.dateTo': '到',
    'whatsapp.dm.summarize': '总结',
    'whatsapp.dm.summarizeDone': '私信摘要生成成功。',
    'whatsapp.dm.summarizeFailed': '无法生成私信摘要。',
    'whatsapp.dm.botSender': '机器人',
    'whatsapp.dm.media.attachment': '附件',
    'whatsapp.dm.summaries.title': '摘要',
    'whatsapp.dm.summaries.empty': '暂无摘要。',
    'whatsapp.dm.summaries.date': '日期',
    'whatsapp.dm.summaries.excerpt': '摘录',
    'whatsapp.dm.summaries.modalTitle': '私信摘要',
    'whatsapp.dm.stats.contacts': '联系人',
    'whatsapp.dm.syncMessages.button': '同步消息',
    'whatsapp.dm.syncMessages.failed': '同步消息失败',
    'whatsapp.dm.sendMessage.title': '发送消息',
    'whatsapp.dm.sendMessage.placeholder': '输入消息...',
    'whatsapp.dm.sendMessage.send': '发送',
    'whatsapp.dm.sendMessage.success': '消息发送成功',
    'whatsapp.dm.sendMessage.failed': '消息发送失败',
    'whatsapp.dm.media.download': '下载',
    'whatsapp.dm.media.downloading': '下载中...',
    'whatsapp.dm.media.downloadFailed': '媒体下载失败',
    'whatsapp.dm.stats.total': '总计',
};
